import Authentication from "./authentication.service";

const authenticationModule = angular
  .module("app.services.authentication", [])
  .service("Authentication", Authentication);

export default authenticationModule;



// WEBPACK FOOTER //
// ./src/services/authentication/authentication.module.js